import { ProjectWithComments } from '../../../../types/project'
import { useStagesManagement } from '../../../../hooks/useStagesManagement'
import React, { useEffect, useState } from 'react'

interface StagesManagementProps {
  project: ProjectWithComments
}

export const StagesManagement = ({
  project: initialProject
}: StagesManagementProps) => {
  const [project, setProject] = useState(initialProject)

  const {
    isAddingStage,
    setIsAddingStage,
    newStageName,
    setNewStageName,
    newStageStartDate,
    setNewStageStartDate,
    newStageEndDate,
    setNewStageEndDate,
    editedStageName,
    setEditedStageName,
    editedStageStartDate,
    setEditedStageStartDate,
    editedStageEndDate,
    setEditedStageEndDate,
    isEditingStage,
    setIsEditingStage,
    handleAddStage,
    handleUpdateStage,
    handleDeleteStage,
    handleStartEditingStage,
    fetchProject
  } = useStagesManagement(initialProject.id)

  const refreshStages = async () => {
    const updatedProject = await fetchProject()
    if (updatedProject != null) {
      setProject(updatedProject.data as ProjectWithComments)
    }
  }

  useEffect(() => {
    setProject(initialProject)
  }, [initialProject])

  return (
    <>
      <div className='row mb-30'>
        <div className='col-sm-12'>
          <div className='card p-20'>
            <div className='projectCard'>
              <div className='d-flex justify-content-between align-items-center tw-gap-x-4 mb-20'>
                <h4 className='tw-font-semibold'>Etapy projektu</h4>
                <button
                  className={`
                                          tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                          tw-text-white
                                          tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                        `}
                  onClick={() => setIsAddingStage(true)}
                >
                  <i className='fa fa-plus mr-10' /> Dodaj etap
                </button>
              </div>

              {isAddingStage && (
                <div className='mb-20'>
                  <div>
                    <div className='row'>
                        <div className='col-md-4 mb-2'>
                            <input
                                type='text'
                                className='form-control'
                                placeholder='Nazwa etapu'
                                value={newStageName}
                                onChange={(e) => setNewStageName(e.target.value)}
                              />
                          </div>
                        <div className='col-md-3 mb-2'>
                            <input
                                type='date'
                                className='form-control'
                                placeholder='Data rozpoczęcia'
                                value={newStageStartDate}
                                onChange={(e) => setNewStageStartDate(e.target.value)}
                              />
                          </div>
                        <div className='col-md-3 mb-2'>
                            <input
                                type='date'
                                className='form-control'
                                placeholder='Data zakończenia'
                                value={newStageEndDate}
                                onChange={(e) => setNewStageEndDate(e.target.value)}
                              />
                          </div>
                      </div>
                    <div className='tw-my-2 tw-flex tw-items-center'>
                        <button
                            className={`
                                                  tw-mr-4 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                                  tw-text-white
                                                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-red-500 hover:tw-bg-opacity-90 focus:tw-bg-red-500
                                                `}
                            onClick={() => {
                                setIsAddingStage(false)
                                setNewStageName('')
                                setNewStageStartDate('')
                                setNewStageEndDate('')
                              }}
                          >
                                              Anuluj
                          </button>

                        <button
                            className={`
                                                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                                      tw-text-white
                                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                                    `}
                            onClick={async () => {
                                await handleAddStage()
                                await refreshStages()
                              }}
                            disabled={!newStageName.trim()}
                          >
                                              Dodaj
                          </button>
                      </div>
                  </div>
                </div>
              )}

              {project?.stages.length === 0
                ? (
                  <div className='alert alert-info'>
                    Brak etapów. Dodaj pierwszy etap, aby móc dodawać elementy do projektu.
                                </div>
                  )
                : (
                  <div className='table-responsive'>
                    <table className='table table-bordered table-sm'>
                        <thead>
                            <tr>
                                <th style={{ width: '50px' }}>#</th>
                                <th>Nazwa etapu</th>
                                <th>Data rozpoczęcia</th>
                                <th>Data zakończenia</th>
                                <th style={{ width: '120px' }}>Akcje</th>
                              </tr>
                          </thead>
                        <tbody>
                            {project?.scheduleStages?.map((stage, index) => (
                                <tr key={stage.id} style={{ height: '38px' }}>
                                    <td style={{ verticalAlign: 'middle', padding: '4px 8px' }}>{index + 1}</td>
                                    <td style={{ verticalAlign: 'middle', padding: '4px 8px' }}>
                                        {isEditingStage === stage.id
                                            ? (
                  <input
                                                type='text'
                                                className='form-control form-control-sm'
                                                style={{ minHeight: 28, padding: '2px 8px' }}
                                                value={editedStageName}
                                                onChange={(e) => setEditedStageName(e.target.value)}
                                              />
                                              )
                                            : (
                                                stage.name
                                              )}
                                      </td>
                                    <td style={{ verticalAlign: 'middle', padding: '4px 8px' }}>
                                        {isEditingStage === stage.id
                                            ? (
                  <input
                                                type='date'
                                                className='form-control form-control-sm'
                                                style={{ minHeight: 28, padding: '2px 8px' }}
                                                value={editedStageStartDate}
                                                onChange={(e) => setEditedStageStartDate(e.target.value)}
                                              />
                                              )
                                            : (
                                                stage.startDate ? new Date(stage.startDate).toLocaleDateString('pl-PL') : '-'
                                              )}
                                      </td>
                                    <td style={{ verticalAlign: 'middle', padding: '4px 8px' }}>
                                        {isEditingStage === stage.id
                                            ? (
                  <input
                                                type='date'
                                                className='form-control form-control-sm'
                                                style={{ minHeight: 28, padding: '2px 8px' }}
                                                value={editedStageEndDate}
                                                onChange={(e) => setEditedStageEndDate(e.target.value)}
                                              />
                                              )
                                            : (
                                                stage.endDate ? new Date(stage.endDate).toLocaleDateString('pl-PL') : '-'
                                              )}
                                      </td>
                                    <td style={{ verticalAlign: 'middle', padding: '2px 4px', display: 'flex', alignItems: 'center', gap: '2px' }}>
                                        {isEditingStage === stage.id
                                            ? (
                  <>
                                                <button
                                                    className='btn btn-sm btn-link text-secondary'
                                                    onClick={() => {
                                                        setIsEditingStage(null)
                                                        setEditedStageName('')
                                                        setEditedStageStartDate('')
                                                        setEditedStageEndDate('')
                                                      }}
                                                    title='Anuluj'
                                                  >
                                                    <i className='fa fa-times' />
                                                  </button>
                                                <button
                                                    className='btn btn-sm btn-link text-success'
                                                    onClick={async () => {
                                                        await handleUpdateStage(stage.id.toString())
                                                        await refreshStages()
                                                      }}
                                                    disabled={!editedStageName.trim()}
                                                    title='Zapisz'
                                                  >
                                                    <i className='fa fa-check' />
                                                  </button>
                                              </>
                                              )
                                            : (
                  <>
                                                <button
                                                    className='btn btn-sm btn-link text-primary'
                                                    onClick={() => handleStartEditingStage(
                                                        stage.id,
                                                        stage.name,
                                                        stage.startDate,
                                                        stage.endDate
                                                      )}
                                                    title='Edytuj'
                                                  >
                                                    <i className='fa fa-edit' />
                                                  </button>
                                                <button
                                                    className='btn btn-sm btn-link text-danger'
                                                    onClick={async () => {
                                                        await handleDeleteStage(stage.id.toString())
                                                        await refreshStages()
                                                      }}
                                                    title='Usuń'
                                                  >
                                                    <i className='fa fa-trash' />
                                                  </button>
                                              </>
                                              )}
                                      </td>
                                  </tr>
                              ))}
                          </tbody>
                      </table>
                  </div>
                  )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
